import { Grid, Stack, Tabs } from "@flpstudio/design-system";
import type react from "react";

import { useScreenSize } from "@/hooks/use-screen-size";

type Props = {
  documentNode: react.ReactNode;
  bookingNode: react.ReactNode;
  commentNode: react.ReactNode;
  signUpCallNode?: react.ReactNode;
};

export function ViewerLayout(props: Props) {
  const { isLg } = useScreenSize();

  if (isLg) {
    return (
      <Grid columns={24}>
        <Grid.Col span={15}>{props.documentNode}</Grid.Col>
        <Grid.Col span={9} className="flex flex-col gap-4">
          {props.signUpCallNode}
          {props.bookingNode}
          {props.commentNode}
        </Grid.Col>
      </Grid>
    );
  }

  return (
    <Stack>
      {props.bookingNode}
      <Tabs defaultValue="document">
        <Tabs.List component="nav" className="-mx-6 bg-white px-6 shadow-sm">
          <Tabs.Tab
            className="mt-1 rounded-none pb-[0.8rem] data-[active=true]:font-semibold data-[active=true]:text-[--mantine-color-text]"
            value="document"
          >
            Document
          </Tabs.Tab>
          <Tabs.Tab
            className="mt-1 rounded-none pb-[0.8rem] data-[active=true]:font-semibold data-[active=true]:text-[--mantine-color-text]"
            value="discussion"
          >
            Discussion
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="document">{props.documentNode}</Tabs.Panel>
        <Tabs.Panel value="discussion">{props.commentNode}</Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
